import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "BoardsDropdown",
  props: {
    profile: {
      type: Object,
      required: true
    },
    update: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    currentBoard: {
      type: [String, Number],
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    inactive: {
      type: Boolean,
      default: false
    },
    fetchBoards: {
      type: Boolean,
      default: true
    },
    dropLeft: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: "white"
    },
    toggleClass: {
      type: String,
      default: ""
    },
    menuClass: {
      type: String,
      default: ""
    },
    openOnHover: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [BOARDS])), {}, {
    boardId() {
      var _statusLabels$;
      const {
        statusLabels
      } = this.profile;
      return statusLabels == null ? void 0 : (_statusLabels$ = statusLabels[0]) == null ? void 0 : _statusLabels$.boardId;
    }
  }),
  mounted() {
    if (this.fetchBoards && !this.BOARDS.length) this.LOAD_BOARDS();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARDS])), {}, {
    getHref() {
      return `#/clients/board?boardId=${this.currentBoard}`;
    },
    async transferProfile(boardId) {
      const {
        details: {
          statusLabelId
        }
      } = this.profile;
      const {
        clientProfileId: id
      } = this;
      this.$emit("transfer-profile", {
        statusLabelId,
        id,
        currentBoard: this.boardId,
        boardId,
        inactive: this.inactive
      });
    },
    onOver() {
      if (!this.openOnHover) return;
      this.$refs.dropdown.visible = true;
    },
    onLeave() {
      if (!this.openOnHover) return;
      this.$refs.dropdown.visible = false;
    }
  })
});